import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    headerMenueDrawer: false,
}

const uiSlice=createSlice({
    name: 'ui',
    initialState,
    reducers:{
        toggleHeaderMenueDrawer:(state)=>{
            state.headerMenueDrawer=!state.headerMenueDrawer
        },
    }
});

export const {
    toggleHeaderMenueDrawer,
}=uiSlice.actions;

export default uiSlice.reducer;